import React, { Component, PropTypes } from 'react'
import { fromJS } from 'immutable'
import AdminNavbar from '../../components/AdminNavbar'
import styled from 'styled-components'
import { searchContinents } from '../../sources/SearchSource'
import { deleteContinent } from '../../sources/AdminSource'
import { translate } from 'react-i18next'
import CardContainer from '../../components/CardContainer'
import Trash from '../../svg-icons/Trash'
import Input from '../../components/Input'
import ThemeContainer from '../../components/ThemeContainer'
import { Metrics, Fonts } from '../../Themes'
import ErrorModal from '../../components/Modal/ErrorModal'
import DialogModal from '../../components/Modal/DialogModal'

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.base};
`

const Container = styled.div`
  overflow-y: scroll;
  max-height: ${Metrics.components.adminContent};
`

const List = styled.div`margin-top: ${Metrics.margins.base};`

const Name = styled.div`${Fonts.style.Label};`

const ThrashContainer = styled.div`
  position: absolute;
  right: 0;
  top: ${Metrics.margins.base};
`

const Continent = styled.div`
  border-bottom: ${Metrics.borders.default};
  height: 50px;
  cursor: pointer;
  padding: 18px 0;
  position: relative;
`

const SearchContainer = styled.div`
  border-bottom: ${Metrics.borders.defaultBorder};
  height: 50px;
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding-left: ${Metrics.components.customThemeSpacing} !important;
  padding-right: ${Metrics.components.customThemeSpacing} !important;
`

class AdminContinents extends Component {
  constructor (props) {
    super(props)
    this.state = {
      continents: [],
      continentToDelete: null,
      name: '',
      modal: false
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.fetchContinents = this.fetchContinents.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { name, modal, continents, continentToDelete } = this.state
    if (
      name !== nextState.name ||
      modal !== nextState.modal ||
      !fromJS(nextState.continents).equals(fromJS(continents)) ||
      continentToDelete !== nextState.continentToDelete
    ) {
      return true
    }
    return false
  }

  componentWillMount () {
    this.fetchContinents()
  }

  handleChange (event) {
    this.setState({ name: event.target.value }, () => {
      searchContinents({
        where: { name: { startsWith: this.state.name } },
        sort: 'name ASC'
      })
        .then(response => this.setState({ continents: response.data }))
        .catch(error => console.log(error))
    })
  }

  fetchContinents () {
    searchContinents({ sort: 'name ASC' })
      .then(response => this.setState({ continents: response.data }))
      .catch(error => console.log(error))
  }

  handleDelete () {
    deleteContinent(this.state.continentToDelete.id)
      .then(response => {
        this.setState({ modal: false, name: '' }, () => this.fetchContinents())
      })
      .catch(error => {
        console.log(error)
        this.toggleModal('error')
      })
  }

  toggleModal (modal) {
    this.setState({ modal })
  }

  render () {
    const { t, admin, dropdownLinks, router } = this.props
    const { name, continents, modal } = this.state
    return (
      <div>
        <AdminNavbar
          admin={admin}
          fixedSearchBar
          dropdownLinks={dropdownLinks}
          rightSideActions={[
            {
              label: t('Create Continent'),
              secondary: true,
              onClick: () => router.push(`/admin/locations/continents/new`)
            }
          ]}
        />
        <ErrorModal
          visible={modal === 'error'}
          message={t('There was a problem when deleting a continent')}
          closeAction={() => this.toggleModal(false)}
          header={t('Error')}
        />
        <DialogModal
          visible={modal === 'dialog'}
          message={t('Do you want to delete this continent?')}
          closeAction={() => this.toggleModal(false)}
          buttons={{
            apply: { label: t('Delete'), onClick: this.handleDelete },
            cancel: {
              label: t('Cancel'),
              onClick: () => this.toggleModal(false)
            }
          }}
        />
        <Container>
          <CustomThemeContainer>
            <CustomCardContainer title={t('Continents')}>
              <SearchContainer>
                <Input
                  handleChange={this.handleChange}
                  value={name}
                  placeholder={t('Search for continents')}
                />
              </SearchContainer>
              <List>
                {continents &&
                  continents.length > 0 &&
                  continents.map((continent, index) => {
                    return (
                      <Continent
                        key={`continent-${continent.name}-${index}`}
                        onClick={() =>
                          router.push(
                            `/admin/locations/continents/${continent.id}`
                          )}>
                        <Name>{continent.name}</Name>
                        <ThrashContainer>
                          <Trash
                            onClick={event => {
                              event.stopPropagation()
                              this.setState({
                                continentToDelete: continent,
                                modal: 'dialog'
                              })
                            }}
                          />
                        </ThrashContainer>
                      </Continent>
                    )
                  })}
              </List>
            </CustomCardContainer>
          </CustomThemeContainer>
        </Container>
      </div>
    )
  }
}

AdminContinents.propTypes = {
  t: PropTypes.func,
  router: PropTypes.object,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'admin' ], { wait: true })(AdminContinents)



// WEBPACK FOOTER //
// ./src/pages/AdminLocations/AdminContinents.js